let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lUlCu"), load("gt1ja")]).then(() => parcelRequire('98w9o'));